<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="''" />
		<CommonFlame :title="title">
			<div class="table-container">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="printedMatters"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="selectItem(item)">
							<td>{{ item.name }}</td>
							<td>{{ item.style_i18n }}</td>
							<td>{{ item.department ? item.department.name : "" }}</td>
							<td>{{ item.user.full_name }}</td>
							<td>{{ common.formatDateTime(item.created_at) }}</td>
						</tr>
					</template>
				</v-data-table>
				<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
			</div>
		</CommonFlame>
		<PrintedMatterSelectDialog :dialog.sync="dialog" :id="selectedId" />
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import Qs from "qs"

import PaginationModule from "../../modules/PaginationModule.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import PrintedMatterSelectDialog from "./components/PrintedMatterSelectDialog.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		PrintedMatterSelectDialog,
	},
	data() {
		return {
			title: "印刷物一覧",
			printedMatters: [],
			selectedId: null,
			dialog: false,
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			headers: [
				{ text: "印刷物名", width: "150px", value: "name" },
				{ text: "書類の種類", width: "150px", value: "style_i18n" },
				{ text: "部門名", width: "150px", value: "department.name" },
				{ text: "作成者", width: "200px", value: "user.last_name" },
				{ text: "登録日", width: "200px", value: "created_at" },
			],
			common,
		}
	},
	mounted() {
		this.fetchPrintedMatters(1)
	},
	methods: {
		fetchPrintedMatters(page) {
			const headers = authenticate.setHeader()
			const params = { page }
			// const params = { q: this.q, page }
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })
			axios
				.get(`/erp/v1/printed_matters`, { params, paramsSerializer, headers })
				.then((res) => {
					this.printedMatters = res.data.printed_matters
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.searchPrintedMatters(page)
		},
		selectItem(item) {
			if (item.document_type == "customer_order") {
				this.$router.push({
					name: "printed_matter_show",
					params: { id: item.id },
				})
			} else {
				this.selectedId = item.id
				this.dialog = true
			}
		},
	},
}
</script>
